var path = 'components/legend-config-button.tpl.html';
var html = "\n<md-button ng-disabled=\"disabled\" class=\"md-raised md-primary\" ng-click=\"openEditMode($event)\">\n    <ng-md-icon icon=\"toc\"></ng-md-icon>\n    <span translate>legend.settings</span>\n</md-button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/legend-config-button.tpl.html
// module id = 1407
// module chunks = 1